import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-redux-form';
import { Row, Col } from 'react-bootstrap';
import Translation from '../../../../../common/translation/translation.component';
import { TRANSLATIONS as translation } from '../../../../../../utils/constant.utils';
import {
    ORFButton
    , ORFSearchSuggestions as SearchSuggestions
    , OR_RRF_Select as Select
    , OR_RRF_TextArea as TextArea
} from '../../../../../common/forms/order-request-form.component';
import { createRequestActions } from "./../../../../../../store/external/request-reducer/create-request.reducer";
import { requestLogActions } from "./../../../../../../store/external/request-reducer/request-log.reducer";
import { wirelineUpgradeCircuitActions } from "./../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/wireline-upgrade-circuit.reducer";

class WirelineUpgradeCircuitForm extends Component {
    constructor(props) {
        super(props);
    }

    componentWillUnmount() {
        this.props.resetWirelineUpgradeCircuit();
        this.props.resetRequestData();
    }

    submitRequest = async () => {
        const { submitRequest, modalMessage, fetchRequestLogItems } = this.props;

        var success = await submitRequest();
        if (success.Success) {
            fetchRequestLogItems(0);
        }
        modalMessage(success);
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose) {
            modalClose();
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    };

    render() {
        const {
            //form
            wirelineUpgradeCircuitFormA
            //reducer action
            , onSubscriptionSelect
            , fetchSubscriptionByValue
            , onPlanSelect
        } = this.props;

        const { subscriptionList } = this.props.createRequest;
        const { formSubmitted, planOptions, primaryPlanDetails, vendorDetails, subscription } = this.props.wirelineUpgradeCircuitRequest;

        return (
            <div>
                <Form method="post" role="form"
                    model="wirelineUpgradeCircuitFormA"
                    onSubmit={this.submitRequest}
                >
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            <SearchSuggestions
                                value={wirelineUpgradeCircuitFormA.circuitCode}
                                label={<Translation translationKey="subscription_number" />}
                                propDisplay={'CircuitCode'}
                                options={subscriptionList.length > 0 ? subscriptionList : ''}
                                onChangeAction={onSubscriptionSelect}
                                searchAction={fetchSubscriptionByValue}
                            />
                            {wirelineUpgradeCircuitFormA.circuitCode != '' &&
                                <div className="pb-15-pl-30">
                                    {subscription.PlanName} <span>&#8226;</span> {subscription.VendorName} <span>&#8226;</span> {subscription.SimName}
                                </div>
                            }
                        </Col>
                    </Row>
                    <div>
                        <h5 className="order-detail-location-title"><Translation translationKey="change_plan_to" /></h5>
                        <span><Translation translationKey="new_price_plan" /></span>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <Select
                                    className="form-control"
                                    label={<Translation translationKey="plan" />}
                                    value={wirelineUpgradeCircuitFormA.planId}
                                    options={planOptions}
                                    placeholder={this.toLocaleLanguage('select_a_plan')}
                                    fieldProp='.planId'
                                    onChangeAction={onPlanSelect}
                                    disabled={wirelineUpgradeCircuitFormA.circuitId == 0}
                                />
                            </Col>
                        </Row>
                        {/* strt */}
                        <div className="price-plan-details-container">
                            <div className="price-plan-left-details">
                                <div className="price-plan-header">
                                    <span><Translation translationKey="plan_details" /></span>
                                </div>
                                <div className="price-plan-list">
                                    {
                                        primaryPlanDetails.PlanId > 0 ?
                                            <div>
                                                <span>{primaryPlanDetails.ComponentName}</span>
                                                <br />
                                                <span><b>{primaryPlanDetails.ComponentDetails}</b></span>
                                            </div> : <span><Translation translationKey="no_selected_plan" /></span>
                                    }
                                </div>
                            </div>

                            <div className="price-plan-center-details">
                                <div className="price-plan-header">
                                    <span><Translation translationKey="other_features" /></span>
                                </div>
                            </div>

                        </div>
                        {/* END */}
                        <div className="price-plan-total-cost-container">
                            <div className="price-plan-header">
                                <span><Translation translationKey="estimated_monthly_cost" /></span>
                            </div>
                            <div className="price-plan-total">
                                <span>{vendorDetails.Currency}</span>
                                <span>{primaryPlanDetails.ComponentCost.toFixed(2)}</span>
                            </div>
                        </div>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <TextArea 
                                    label={<Translation translationKey="business_justification" />}
                                    fieldProp='.businessJustification'
                                    value={wirelineUpgradeCircuitFormA.businessJustification}
                                    disabled={wirelineUpgradeCircuitFormA.circuitId == 0}
                                    maxLength="350"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <TextArea 
                                    label={<Translation translationKey="additional_information" />}
                                    fieldProp='.additionalInformation'
                                    value={wirelineUpgradeCircuitFormA.additionalInformation}
                                    disabled={wirelineUpgradeCircuitFormA.circuitId == 0}
                                    maxLength="350"
                                />
                            </Col>
                        </Row>

                    </div>
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <ORFButton
                                label={<Translation translationKey="modal_close_cancel_button" />}
                                variant={"light"}
                                action={this.onClickCancel}
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <ORFButton
                                    label={<Translation translationKey="submit_request_button" />}
                                    variant={"primary"}
                                    type="type"
                                    disabled={wirelineUpgradeCircuitFormA.circuitId == 0
                                        || wirelineUpgradeCircuitFormA.planId == 0
                                        || wirelineUpgradeCircuitFormA.businessJustification == ''
                                        || formSubmitted}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        );
    }
};

export default connect(
    state => {
        const { wirelineUpgradeCircuitRequest, createRequest, translation } = state;
        const { wirelineUpgradeCircuitFormA } = state.form;
        return {
            wirelineUpgradeCircuitRequest
            , wirelineUpgradeCircuitFormA
            , createRequest
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, wirelineUpgradeCircuitActions
                , createRequestActions
                , requestLogActions),
            dispatch
        )
)(WirelineUpgradeCircuitForm);
